import axios from 'axios';
import {backendHost} from '../../config';

export const getOffersByPartner = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/offer-partner`, {params});
};